<template>
  <div class="rp">
    <div class="col s12">
      Route(s)
    </div>
    <div class="clear"></div>
    <div class="item-row" v-for="(option, index) in liveSelections" v-bind:key="option.id">
      <div class="col-1">
      <person-company
        :data-disabled="globalDisabled"
        :data-index="index"
        @user="$_setUserProps($event, option.id)"
        :dataOptions="$_mapOptions(index)"
    ></person-company>
      </div>
      <div class="col-2">
        <date-picker
          date-format="mm/dd/yyyy"
          :default-date="option.date"
          :data-disabled="globalDisabled"
          @date="$_setDate($event, option.id)"
        >
        Date Sent
        </date-picker>
      </div>
      <div class="col-3">
      <div class="input-field">
      <input
        :disabled="globalDisabled || dataProps.readonly"
        type="text"
        :value="option.notes"
        @input="$_setValues($event, option.id)"
      />
        <label >Notes</label>
      </div>
      </div>
      <div class="col-4">
        <button 
        :disabled="globalDisabled"
        class="btn-floating btn-flat waves-effect" @click="$_removeIndex(option.id)">
          <i class="material-icons grey-text text-darken-3">
            delete
          </i>
        </button>
      </div>
    </div>
    <div class="clear"></div>
    <div class="col s12">
      <button 
      :disabled="globalDisabled"
      class="btn waves-effect rounded z-depth-0" @click="$_addOption()">
        Add Route
      </button>
    </div>
  </div>
</template>
<script>
import core from '@/functions'
import personCompany from '@/components/records/personCompany.component'
import datePicker from '@/components/records/fields/datePicker.component'
export default {
  name:'routeRepeater',
  props:{
    globalDisabled:{
      type:Boolean,
    },
    dataProps:{
      type:Object,
    }
  },
  components:{
    personCompany,
    datePicker
  },
  data(){
    return {
      selections:new Array,
      values:'',
    }
  },
  computed:{
    computedProperties:{
      get(){
        const structure  = () => {
          return {
            label:'Routes',
            layout:'col s12',
            name:'user',
            readonly:false,
            type:'model_select',
            values:this.dataProps.values && this.dataProps.values.length > 0 ? this.dataProps.values[0].user : '',
          }
        }
        return  structure()
      }
    },
    liveSelections:{
      get(){
        return this.selections
      }
    }
  },
  mounted(){
    this.dataProps.values && this.dataProps.values.length > 0 
    ? this.selections = this.dataProps.values
    : false
  },
  methods:{
    $_setUserProps(evt, index){
      let record = this.selections.find(item=> item.id === index)
      record.user  = evt.id
      this.$emit('update', this.selections)
    },
    $_mapOptions(index){
        const structure  = () => {
          return {
            label:'Routes',
            layout:'col s12',
            name:'user',
            readonly:false,
            type:'model_select',
            values:this.dataProps.values && this.dataProps.values.length > 0 ? this.dataProps.values[index].user : '',
          }
        }
        return  structure()
    },
    $_setValues($event,id){
      let record = this.selections.find(item=> item.id === id)
      record.notes = $event.target.value
      this.$emit('update', this.selections)
    },
    $_removeIndex(index){
      let record = this.selections.findIndex(item=> item.id === index)
      this.selections.splice(record, 1)
      this.$emit('update', this.selections)
    },
    $_setDate(value, index){
      let record = this.selections.find(item=> item.id === index)
      let date = core.dateFormat(value.date, 'MM/DD/YYYY')
      record.date = date
      this.$emit('update', this.selections)
    },
    $_addOption(){

      let payload  = {
        id: Math.floor(Math.random() * 999),
        user:false, 
        date: '', 
        notes: new String,
        recieved:false,
      }
      if (!this.$route.name === 'new_record') {
        this.$store.commit('UPDATE_RECORD', {
        id:parseInt(this.$route.params.id),
        prop:'new_routes',
        data:payload,
      })
      }
      this.selections.push(payload)
 
    }
  }
}
</script>
<style lang="scss" scoped>
.rp {
    margin: 24px 2px 16px;
    border: 1px solid #dfdfdf;
    border-radius: 5px;
    padding: 13px;
    .item-row {
    display: flex;
    .col-1 {
      margin-right:12px;
    }
    .col-2 {
      margin-right:12px;
    }
    .col-3 {
    
    }
}
}

</style>